import React from 'react';
import { useHistory } from 'react-router-dom';
import { RouterNavLink, Left, Row, Text } from '../core';

export const BackToVaults = (props: any): JSX.Element => {
  const history = useHistory();
  const prevSearch = history?.location?.state?.prevSearch;
  const url = prevSearch ? `/vaults?chain=${prevSearch}` : '/vaults';
  // todo prevSearch no longer working bc of changes in VaultPageTabs
  return (
    <RouterNavLink
      variant="buttons.tab"
      {...props}
      sx={{ display: 'inline-block', ...props.sx }}
      to={url}
    >
      <Row
        sx={{
          fontSize: 2,
          letterSpacing: 1.1,
          alignItems: 'center',
          textTransform: 'capitalize',
        }}
      >
        <Left mr={1} mb="1px" width="14" height="14" strokeWidth="1.75" />
        Back
      </Row>
    </RouterNavLink>
  );
};
